import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const SignalCellularConnectedNoInternet0BarIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"signal_cellular_connected_no_internet_0_bar"} ref={ref}/>
});

SignalCellularConnectedNoInternet0BarIcon.displayName = "SignalCellularConnectedNoInternet0BarIcon";
